import React, { useEffect } from 'react'
import styled from 'styled-components'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { gsap, Linear } from 'gsap'
import OrX from 'images/or-x-cell-01.inline.svg'
import OrXStripe from 'images/or-x-stripe-01.inline.svg'
import { StaticImage } from 'gatsby-plugin-image'

gsap.registerPlugin(ScrollTrigger)

const Background = ({ location }) => {
    useEffect(() => {
        gsap.to(".parallax-element", {
          scrollTrigger: {
            scrub: true
          }, 
          y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
          ease: "none"
        });
        gsap.from(".background", {
          duration: 1.5,
          delay:  location.state && location.state.source === 'internal' ? 0.6 : 1.5,
          x: "50%",
          y: "-50%"
        })
        gsap.to('.or-x-01', {
          y: -300,
          duration: 30,
          repeat: -1,
          repeatDelay: 0,
          yoyo: true,
        })
        gsap.to('.or-x-01', {
          rotationZ: '+=360',
          duration: 200,
          repeat: -1,
          repeatDelay: 0,
          ease: Linear.easeNone
        })
        gsap.from('.or-x-01', {
          opacity: 0.2,
          duration: 5,
          repeat: -1,
          repeatDelay: 2,
          yoyo: true,
          ease: Linear.easeNone
        })
        
        gsap.from('.or-x-02', {
          opacity: 0,
          duration: 0.5,
          repeat: -1,
          repeatDelay: 0.5,
          yoyo: true,
        })
        gsap.to('.or-x-02', {
          y: 300,
          duration: 10,
          repeat: -1,
          repeatDelay: 0.5,
          yoyo: true,
        })
      }, [])
  
      return (
        <Bg className="w-full h-full relative">
          <div className="background parallax-element" data-speed=".5">
            <StaticImage src="../../../images/bg-landing.png" width="1700" quality="100" formats={['auto','webp']} placeholder="none"  />
          </div>
          <OrX className="or-x-01 parallax-element absolute opacity-30 filter blur" style={{top: '50%', transform: 'translateX(50%)', right: 0}} data-speed=".4" />
          <OrXStripe className="or-x-02 parallax-element absolute opacity-10 filter blur" style={{top: '60%', left: '5%'}} data-speed=".25" />
        </Bg>
      )
}

const Bg = styled.div`
  background: linear-gradient(3.8deg, #0000FF 3.11%, #F03A14 46.87%, #F03A14 79.07%, #0000FF 99.69%);
`

export default Background
